import { Component } from '@grafikr/components';
import Splide from '@splidejs/splide';

export default Component((node, { onMounted }) => {
  const slides = node.querySelectorAll('.splide__slide').length;
  const paginationButtons = node.querySelectorAll<HTMLButtonElement>('[data-go-index]');

  const carousel = new Splide(node, {
    arrows: false,
    autoWidth: true,
    pagination: false,
    drag: slides > 1,
    speed: 1200,
    autoplay: true,
  });

  paginationButtons.forEach((button) => {
    const { goIndex } = button.dataset;

    button.addEventListener('click', () => {
      carousel.go(parseInt(goIndex, 10) - 1);
    });
  });

  onMounted(() => {
    carousel.mount();
  });
});
